import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgMinusCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M22 12q0 10-10 10T2 12 12 2t10 10m-5.757 1a1 1 0 1 0 0-2H7.757a1 1 0 1 0 0 2z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgMinusCircle)
export default ForwardRef
